import { Link } from 'react-router-dom';
import mascot from '../assets/not-found-mascot.png';
import { MORPH_BTN } from '../lib/ui.js';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-white dark:bg-neutral-950">
      <img src={mascot} alt="" className="w-40 h-40 sm:w-48 sm:h-48 object-contain mb-2 select-none pointer-events-none" draggable="false" />
      <h1 className="font-display text-3xl font-bold text-neutral-900 dark:text-white mb-2">404</h1>
      <p className="text-neutral-500 dark:text-neutral-400 mb-6">Halaman tidak ditemukan.</p>
      <Link to="/" className={`px-6 py-3 rounded-full font-bold text-white ${MORPH_BTN}`} style={{ background: 'var(--accent)' }}>Kembali ke Beranda</Link>
    </div>
  );
}
